import React, { Fragment, useRef } from 'react'
import { Table, TableBody, TableCell, TableContainer,
   TableHead, TableRow, Paper, TablePagination} from '@mui/material';
import TextField from '@mui/material/TextField';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import TableFooter from '@mui/material/TableFooter';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Box from '@mui/material/Box';
import { useState } from 'react';
import styled from 'styled-components';
import { useEffect } from 'react';
import * as XLSX from 'xlsx'
import Popup from 'reactjs-popup';
import PopupTable from '../PopupTable';
import {HeadingWrap, Span, CommonButton } from '../../Styles/CommonStyles';
import { useAddBulkUserMutation, useGetUsersQuery } from '../../features/users/usersApiSlice';
import CircularProgress from '@mui/material/CircularProgress';
import {useGetofficetypeQuery} from '../../features/officetype/officetypeApiSlice';
import {useGetofficesQuery} from '../../features/offices/officesApiSlice';
import ExcelDownload from '../../data/exceldownload';



const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;


const Addcategcont =styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
`
const Addcategform = styled.form`
  display: flex;
  margin:10px;
`
const Displaydiv1 = styled.div`

`
const HeadingField = styled.div`
  font-weight: bold;
  margin-bottom:20px;
  margin-top:15px;
`
const FormEleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items:center;
`
const Button2Div =styled.div`
  display: flex;
  justify-content: end;
`

const AssetCategoryWrapper = styled.div`

`
const Label = styled.label`
    width: 140px;
    margin: 10px;
`

const SuggestSearchWrapper = styled.div`

`
const SubmitButton = styled(CommonButton)`
  height:"40px";
  margin-top:"0px";
  margin-bottom:"0px";
`
const CustomFileUploadButton = styled.label`
  /* Add your desired button styles */
  background-color: #4caf50; /* Green */
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`
const BulkWrapper = styled.div`
  display: flex;
  align-items:center;
`

const FormItemdiv = styled.div`

`
const ViewModalWrapper = styled.div`
    font-size: 12px;
`
const CloseModalButton = styled.button`
  cursor: pointer;
  position: absolute;
  display: block;
  padding: 2px 5px;
  line-height: 20px;
  right: -10px;
  top: -10px;
  font-size: 24px;
  background: #ffffff;
  border-radius: 18px;
  border: 1px solid #cfcece;
`
const InputFile = styled.input`
  width: 180px;
  display: none;
`
const SearchDiv =styled.div`
  position: absolute;
  background-color: white;
  overflow-y: auto;
  height: 400px;
  z-index: 100;
  /* outline: 1px solid black; */
`

const SelectFileReset = styled.button`
  margin-right: 10px;
`


function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };


  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};


// Function to check for duplicates
const checkDuplicates = (arr, key) => {
  const seen = new Set();
  const duplicates = new Set();

  arr.forEach(item => {
      const value = item[key];
      if (seen.has(value)) {
          duplicates.add(value);
      } else {
          seen.add(value);
      }
  });

  return duplicates;
};


export default function CustomPaginationActionsTable() {

  const initialUserState = {
    name:{firstName:"", middleName:"", lastName:""},
    email:"",
    password: "",
    mobileNo:"",
    officeLandLine:"",
    employeeID: "",
    officeAddress:"",
    office: {mainCharge:"", additionalCharge:[]},
    designation:{},
    designationSuffix:{},
    numSuffix:{},
    roles:{main:["user"]},
    assets:{},
    indi_assets:[],
    bo_assets:{},
    store_assets:{},
    active:true
}

  const {users} = useGetUsersQuery("users", {
    selectFromResult: ({ data }) => ({
      users: data?.entities
    }),
  })

  const {officetype} = useGetofficetypeQuery("officetype",{
    selectFromResult: ({ data }) => ({
      officetype: data?.entities
    }),
  })
  const {offices} = useGetofficesQuery("offices", {
    selectFromResult: ({ data }) => ({
      offices: data?.entities
    }),
  })


  const [addBulkUsers,{
    isLoading,
    isSuccess,
    isError,
    error
  }] = useAddBulkUserMutation();

  const inputFile = useRef(null);
  const [tabledata, setTabledata]= useState([]);
  const [editFormData, setEditFormData]=useState({});
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState(null);
  const [duplicateValues, setDuplicateValues] = useState();
  const [invalidValues, setInvalidValues] = useState();
  const [finalFile, setFinalFile] = useState([]);
  const [downloadData, setDownloadData] = useState({});
  const [bulkDataAdded, setBulkDataAdded] = useState(false);
  const [sentData, setSentData ]= useState(0);
  const [fileName, setFileName] = useState("");
  const [subject, setSubject] = useState({
    subjectValue: [...Array(tabledata.length).fill("")],
    subjectIndex: ""
  });
  const [validEmailId, setValidEmailId] = useState(false);
  const [emailIDFocus, setEmailIdFocus] = useState(false);


  const handleButtonClick = () => {
    inputFile.current.click();
  };

  console.log(file)

  const assignFunction = (data) => {
    setFile(data);
    let reducedArray = [];
    let invalidValues = [];
    const tempArray = [...data];
    for(let val of tempArray){
      let tempObj = {name:val.name}
      if(EMAIL_REGEX.test(val.name)){
      reducedArray.push(tempObj)
      }else{
        invalidValues.push(tempObj)
      }
    }
    setInvalidValues(invalidValues);
    const nameArray = Object.values(users).map(item => item.email);
    setDuplicateValues(reducedArray.filter(item => nameArray.includes(item.name)));   
    setFinalFile((reducedArray.filter(item => !nameArray.includes(item.name))));
  }

  const onBulkSubmit = async (e) =>{
    e.preventDefault();
    let tempFile = structuredClone(file)
    let finalArray = []
    for(let val of tempFile){
      console.log(val)
      let tempObject = {}
      let tempUser = structuredClone(initialUserState);
      tempUser.name.firstName = val.name?.trim();
      tempUser.email = val.email?.trim();
      tempUser.password = val?.password?.trim();
      tempUser.mobileNo =  typeof val.mobile === "number"? val.mobile?.toString().trim(): "";
      // val.mobile.toString().trim();
      // tempUser.employeeID = val.employeeID?.length? val.employeeID.toString().trim():"Not Available";
      if(val?.office?.length && val?.office?.split(",")?.length === 1){
        tempUser.office.mainCharge = val.office.trim();
      }else{
        if(val?.office?.length && val.office?.split(",")?.length){
        tempUser.office.mainCharge = val.office?.split(",")[0]?.trim();
        tempUser.office.additionalCharge = val.office?.split(",")?.filter((item,index) => index !== 0).map(x => x.trim());
        }
      }
      for( let value of Object.values(tempUser.office).flat(3)){
        tempUser.designation[value] = val.designation;
        // Check if the Office type pertaining to the current office has the array of unitHeads which includes the current designation.
        
        if(Object.values(officetype).find(x => x?.type === (Object.values(offices)?.find(x=> x?.name === value)?.type))?.unitHead.includes(tempUser.designation[value])){
          tempUser.roles[value] = ["UnitHead"];
        }
      }
      finalArray.push(tempUser)
    }
    console.log(finalArray)
    try{
      const result = await addBulkUsers({"data":finalArray});
      console.log(result)
      if(result.data.success.length){
        setBulkDataAdded(true);
        alert(`${result.data.success}`)  
        inputFile.current.value = null
        setFile(null)
      }
    } catch{}

  }

  const deleteSelectFile = () => {
    if(inputFile.current){
      inputFile.current.value = "";
      inputFile.current.type = "text"; 
      inputFile.current.type = "file";
      setFile(null)
    }
  }

  const fileType = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"]
  const handleChangeEmail = (e) => {
    let selectedFile = e.target.files[0]
    if(selectedFile){
      if(fileType.includes(selectedFile.type)){
        setFileName(selectedFile.name)
        let reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile)
        reader.onload = (e) => {
          setFileError(null);
          const workbook = XLSX.read(e.target.result, {type:'buffer' });
          const worksheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[worksheetName];
          const data = XLSX.utils.sheet_to_json(worksheet);
          const duplicateEmails = checkDuplicates(data, "email");
          if([...duplicateEmails]?.length) alert(`Please check duplicate entries in uploaded excel: ${[...duplicateEmails]}`)
          console.log(data)
          assignFunction(data);
        }
      }else{
        setFileError("Please Select Correct File Type")
        setFile(null)
      }
    }else{
      setFileError("no file selected")
      setFile(null) 
    }
  }
  //Setting the download data for excel download.
  useEffect(()=>{
    let finalDownloadData = [];
    let finalSortedDownloadData = [];
    const keyOrderArray = ["name"]
    let tempDownloadData = structuredClone(tabledata);
    for(let val of tempDownloadData ){
        let {_id, ...others} = val;
        others = {...others, ["name"]: val.name }
        finalDownloadData.push(others)
      }
      for(let value of finalDownloadData){
          let tempObject = {}
          for(let val of keyOrderArray){
              tempObject = {...tempObject, [val]:value[val]};
          }
          finalSortedDownloadData.push(tempObject);
      }
      setDownloadData(finalSortedDownloadData)
  }, [tabledata])

  const templateData = [
    {  name: "John Doe", designation: "Director" , email: "john@example.com", office:"Finance", password:"Password@1"},
    {  name: "Jane Smith", designation: "Manager" , email: "jane@example.com", office:"IT", password:"Password@2" },
    {  name: "Peter Jones", designation: "Junior Engineer", email: "jane@example.com", office:"Accounts, HR", password:"Password@3" },

  ];
 
   console.log(file)
  return (
    <>
   
    <Displaydiv1>    

    <form onSubmit={onBulkSubmit}>
      <HeadingWrap>
        <Span>Upload Bulk Users</Span>
      </HeadingWrap>

      <BulkWrapper>
        <ExcelDownload data={templateData} filename="uploadformat" sheetName="Format" button={true}/>
        <InputFile type="file" onChange={handleChangeEmail} ref={inputFile} />
        <CustomFileUploadButton htmlFor="file-upload" onClick={handleButtonClick}>
          Upload File
        </CustomFileUploadButton>
      {file && <><span>{fileName}</span><SelectFileReset type='button' onClick={() => deleteSelectFile()} >&times;</SelectFileReset>
      <Popup trigger={<SubmitButton type='button'>View File</SubmitButton>} position="right center" modal nested>
              <PopupTable props={file}/>
      </Popup></>}
      <SubmitButton type='submit'>Submit</SubmitButton>
      </BulkWrapper>
    </form>
    {isLoading &&<CircularProgress />}
    </Displaydiv1>
    </>
  );
}